import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ComponentService } from '../../../../../shared/abstract/component.service';
import { environment } from '../../../../../environments/environment';
import { RoleEnums } from '../../../../../shared/enum/authorize';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { RequestService } from '../../../../../shared/services/request.service';
import { TutorialApiService } from '../../../../../shared/services/tutorial-api.service';
import { UserTutorialSettingDto } from '../../../../../shared/interface/UserTutorialSettingDto';
import { MatSidenav } from '@angular/material/sidenav';
import { ModalComponent } from '../../../../../shared/widgets/modal/modal.component';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent extends ComponentService<any> implements OnInit, OnDestroy {
  //@ViewChild('darkModeSwitch') element: MatSlideToggle | undefined;
  @ViewChild('darkModeSwitch', { read: ElementRef }) element: ElementRef | undefined;
  env: any;
  userInfos: any;
  userInitials: any;
  langKey!: string;
  imageUrl: any;
  roleEnums = RoleEnums;
  projects: any;
  apiUrl: any;
  allProjectData: any;
  searchTerm: string = 'Ara';
  selectedCompany: any;
  mobileQuery!: MediaQueryList;
  filteredCompanies!: any;
  companies!: any;
  checked: boolean = true;
  disabled: boolean = false;
  selectedProjectId: any;
  selectedCompanyId: any;
  languageValue;

  /** Tutorial ayarları (UserTutorialSetting) - intro toggle. */
  tutorialRepeatable = true;
  introTourRepeatable = false;
  languages = [
    { value: 'tr-TR', viewValue: 'Türkçe' },
    { value: 'en-US', viewValue: 'English' },
    { value: 'de-DE', viewValue: 'Deutsch' },
    { value: 'ky-KZ', viewValue: 'Arabic' }
  ];

  sidenavOpen: boolean = false;
  @Output() signOut: EventEmitter<void> = new EventEmitter<void>();
  @Output() profileStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  profileInfoIsOpen: boolean = false;
  sun = 'M12 15.5q1.45 0 2.475-1.025Q15.5 13.45 15.5 12q0-1.45-1.025-2.475Q13.45 8.5 12 8.5q-1.45 0-2.475 1.025Q8.5 10.55 8.5 12q0 1.45 1.025 2.475Q10.55 15.5 12 15.5Zm0 1.5q-2.075 0-3.537-1.463T7 12q0-2.075 1.463-3.537T12 7q2.075 0 3.537 1.463T17 12q0 2.075-1.463 3.537T12 17ZM1.75 12.75q-.325 0-.538-.213Q1 12.325 1 12q0-.325.212-.537Q1.425 11.25 1.75 11.25h2.5q.325 0 .537.213Q5 11.675 5 12q0 .325-.213.537-.213.213-.537.213Zm18 0q-.325 0-.538-.213Q19 12.325 19 12q0-.325.212-.537.212-.213.538-.213h2.5q.325 0 .538.213Q23 11.675 23 12q0 .325-.212.537-.212.213-.538.213ZM12 5q-.325 0-.537-.213Q11.25 4.575 11.25 4.25v-2.5q0-.325.213-.538Q11.675 1 12 1q.325 0 .537.212 .213.212 .213.538v2.5q0 .325-.213.537Q12.325 5 12 5Zm0 18q-.325 0-.537-.212-.213-.212-.213-.538v-2.5q0-.325.213-.538Q11.675 19 12 19q.325 0 .537.212 .213.212 .213.538v2.5q0 .325-.213.538Q12.325 23 12 23ZM6 7.05l-1.425-1.4q-.225-.225-.213-.537.013-.312.213-.537.225-.225.537-.225t.537.225L7.05 6q.2.225 .2.525 0 .3-.2.5-.2.225-.513.225-.312 0-.537-.2Zm12.35 12.375L16.95 18q-.2-.225-.2-.538t.225-.512q.2-.225.5-.225t.525.225l1.425 1.4q.225.225 .212.538-.012.313-.212.538-.225.225-.538.225t-.538-.225ZM16.95 7.05q-.225-.225-.225-.525 0-.3.225-.525l1.4-1.425q.225-.225.538-.213.313 .013.538 .213.225 .225.225 .537t-.225.537L18 7.05q-.2.2-.512.2-.312 0-.538-.2ZM4.575 19.425q-.225-.225-.225-.538t.225-.538L6 16.95q.225-.225.525-.225.3 0 .525.225 .225.225 .225.525 0 .3-.225.525l-1.4 1.425q-.225.225-.537.212-.312-.012-.537-.212ZM12 12Z'
  moon = 'M12 21q-3.75 0-6.375-2.625T3 12q0-3.75 2.625-6.375T12 3q.2 0 .425.013 .225.013 .575.038-.9.8-1.4 1.975-.5 1.175-.5 2.475 0 2.25 1.575 3.825Q14.25 12.9 16.5 12.9q1.3 0 2.475-.463T20.95 11.15q.025.3 .038.488Q21 11.825 21 12q0 3.75-2.625 6.375T12 21Zm0-1.5q2.725 0 4.75-1.687t2.525-3.963q-.625.275-1.337.412Q17.225 14.4 16.5 14.4q-2.875 0-4.887-2.013T9.6 7.5q0-.6.125-1.287.125-.687.45-1.562-2.45.675-4.062 2.738Q4.5 9.45 4.5 12q0 3.125 2.188 5.313T12 19.5Zm-.1-7.425Z'

  sidenavOpenPassword = false;
    @ViewChild('rightSidebar') rightSidebar!: MatSidenav;
    @ViewChild('rightSidebarNewPassword') rightSidebarNewPassword!: MatSidenav;
  
  constructor(
    injector: Injector,
    private _router: Router,
    private _dialog: MatDialog,
    private _request: RequestService,
    private _bottomSheet: MatBottomSheet,
    private changeDetectorRef: ChangeDetectorRef,
    private _tutorialApi: TutorialApiService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.userInfos = this._appsService.userInfos;
    this.selectedCompanyId = this._appsService.selectedCompany != null ? (this._appsService.selectedCompany) : this._appsService.existCurrentCompany;
    this.selectedProjectId = this._appsService.selectedProject;
    this.imageUrl = this.userInfos?.userImageUrl ? environment.apiUrl + '/' + this.userInfos?.userImageUrl : 'assets/icons/general/user-icon.png'
    this.companies = this._appsService.companies;
    const storedLang = localStorage.getItem('langKey');
    const langKey = storedLang ? storedLang : 'tr-TR';
    this.languageValue = this.languages.find(l => l.value == langKey)?.value;
    this._appsService.language = this.languageValue;
    this.filteredCompanies = this._appsService.companies;
    this.env = environment;  

    // GetUserInfo result.TutorialSetting + tutorialState (UserDetailModel).
    const anyUser = this.userInfos as any;
    this._appsService.syncTutorialIntroFromTutorialState(anyUser);
    const tutorialSetting = anyUser ? (anyUser.tutorialSetting || anyUser.TutorialSetting) : null;
    if (tutorialSetting) {
      if (tutorialSetting.tutorialRepeatable !== undefined) {
        this.tutorialRepeatable = tutorialSetting.tutorialRepeatable;
      } else if (tutorialSetting.TutorialRepeatable !== undefined) {
        this.tutorialRepeatable = tutorialSetting.TutorialRepeatable;
      }

      if (tutorialSetting.introTourRepeatable !== undefined) {
        this.introTourRepeatable = tutorialSetting.introTourRepeatable;
      } else if (tutorialSetting.IntroTourRepeatable !== undefined) {
        this.introTourRepeatable = tutorialSetting.IntroTourRepeatable;
      }
    }

    let userName = this.userInfos?.firstName?.toUpperCase() + ' ' + this.userInfos?.lastName?.toUpperCase();
    this.getInitials(userName);
  }

  updateTutorialSettings(settings: Partial<UserTutorialSettingDto>): Promise<any> {
    const userId = this._appsService?.userInfos?.id;
    if (userId == null) return Promise.reject(new Error('User id yok'));

    const model: UserTutorialSettingDto = {
      userId,
      tutorialRepeatable: settings.tutorialRepeatable !== undefined ? settings.tutorialRepeatable : this.tutorialRepeatable,
      introTourRepeatable: settings.introTourRepeatable !== undefined ? settings.introTourRepeatable : this.introTourRepeatable
    };

    return this._tutorialApi.updateTutorialSettings(model);
  }

  onIntroTourRepeatableChange(checked: boolean): void {
    this.introTourRepeatable = checked;
    this.updateTutorialSettings({ tutorialRepeatable: this.tutorialRepeatable, introTourRepeatable: checked })
      .catch(() => {
        // Hata olursa UI'ı geri al.
        this.introTourRepeatable = !checked;
        this.changeDetectorRef.markForCheck();
      });
  }


  ngAfterViewInit(): void {
    if (this.element) {
      const onIcon = this.element.nativeElement.querySelector('.mdc-switch__icon--on');
      const offIcon = this.element.nativeElement.querySelector('.mdc-switch__icon--off');

      if (onIcon && offIcon) {
        onIcon.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24"><path d="${this.moon}"></path></svg>`;
        offIcon.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24"><path d="${this.sun}"></path></svg>`;
      }
    }

  }

  ngOnDestroy() {
    
  }

  getInitials(fullName: string): void {
    if (!fullName) {
      this.userInitials = "";
    }

    const names = fullName.split(' ');
    const initials = names.map(name => name.charAt(0).toUpperCase()).join('');
    this.userInitials = initials.substring(0, 2); // Get the first two initials
  }

  onKey(event: Event) {
    const eventValue = (event.target as HTMLInputElement).value;

    this._appsService.filterCompanies = JSON.parse(JSON.stringify(this._appsService.companies))
    this._appsService.filterCompanies = this.search(eventValue);
    if (this._appsService.filterCompanies.length == 0) {
      this._appsService.filterCompanies = JSON.parse(JSON.stringify(this._appsService.companies))
    }
  }

  search(value, type?: any) {
    let filter = value.toLocaleLowerCase('tr-TR');
    //if (type == 'form') {
    //  return this.forms.filter((prd: any) => prd.templateName.toLocaleLowerCase('tr-TR').startsWith(filter));
    //} else {
    //  return this._appsService.filterCompanies.filter(option => option.companyName.toLocaleLowerCase('tr-TR').startsWith(filter));
    //}
    return this._appsService.filterCompanies.filter(option => option.companyName.toLocaleLowerCase('tr-TR').startsWith(filter));

  }



  //search(value, type?: any) {
  //  let filter = value.toLocaleLowerCase('tr-TR');
  //  if (type == 'form') {
  //    return this.forms.filter((prd: any) => prd.templateName.toLocaleLowerCase('tr-TR').startsWith(filter));
  //  } else {
  //    return this._appsService.filterCompanies.filter(option => option.companyName.toLocaleLowerCase('tr-TR').startsWith(filter));
  //  }
  //}

  closeSidebar(): void {
    this.sidenavOpen = !this.sidenavOpen;
    this._appsService.userPanelOpen.next(this.sidenavOpenPassword);
  }

  change(key: string) {
    this._request.setLang(key).then((res) => {
      localStorage.setItem('langKey', key);
      this._appsService.language = key;
      this.translate.setDefaultLang(key);
      this.changeDetectorRef.detectChanges();
    }).finally(() => {
      window.location.reload();
    });
    this._appsService.logInfo("Dil değiştirildi");
  }


  pwdChange() {
    //const dialogRef = this._dialog.open(ModalComponent, {
    //  data: {
    //    type: 'pwdChange',
    //    title: 'UpdatePassword',
    //    body: 'logging',
    //    cancel: 'cancel',
    //    data: { counter: 30 },
    //    ok: 'updatepwd',
    //    color: 'primary'
    //  }
    //});
    //dialogRef.afterClosed().subscribe(result => {
    ////  if (result) {
    ////    const model = new ChangePasswordModel();
    ////    model.currentPassword = result.currentPwd.toString();
    ////    model.newPassword = result.pwd.toString();
    ////    this._service.changePassword(model).toPromise().then((_) => {
    ////      /*this.MessageBox(_.message ?? '', _.code == 1 ? 'mat-primary' : 'mat-warn', 'right');*/
    ////      if (_.code == ResultCode._1) {
    ////        this.MessageBox(_.message ?? '', 'primary', 'center');
    ////      }
    ////      else if (_.code == ResultCode._2) {
    ////        this.MessageBox(_.message ?? '', 'orange', 'center');
    ////      }
    ////      else {
    ////        this.MessageBox(_.message ?? '', 'warn', 'center');
    ////      }
    ////    })
    ////  }
    //})
  }

  support() {
    this._router.navigate(['app/support']);
  }

  managementPanel() {

    //this._router.navigate(['application']);
    window.location.href = '#/application';
    this._appsService.logInfo("Ana sayfa görüntülendi");
  }

  public openUserProfile(): void {
    
    this.sidenavOpen = !this.sidenavOpen;
    this._appsService.userPanelOpen.next(this.sidenavOpen);
    this._appsService.logInfo("Kullanıcı profili görüntülendi");
    //this.profileInfoIsOpen = !this.profileInfoIsOpen;
    //this.profileStatus.emit(this.profileInfoIsOpen)
  }

  public signOutEmit(): void {
    this.signOut.emit();
    this._appsService.logInfo("Uygulamadan çıkıldı");
    //this._router.navigate(['account/login']);
  }

  subProjectControl(projects) {
    let p: any = []
    projects.forEach((project) => {
      p.push(project);
      if (project.inverseParent.length != 0) {
        p.push(...project.inverseParent);
      }
    });
    this.projects = p;
  }


  //updateTemplate() {
  //  let userId = this._appsService.userInfos.id;
  //  this.changeCompany(this.selectedCompanyId).then(() => {
  //    this._appsService.projects = this.projects;
  //    this.onSelectedProject(this.selectedProjectId);
  //    //this.checkAppObjRule();
  //    //this.getAllWorkRules();
  //    //this.checkVrpRule();
  //    //this._utility.setTheme(this.selectedTheme.value);
  //    if (this.base64Image) {
  //      this.updateImageUser(userId).finally(() => {
  //        location.reload();
  //      });
  //    }
  //    else {
  //      location.reload();
  //    }
  //  });    


  //}


  async changeCompany(companyId) {
    return await this._request.setCurrentCompany(companyId).then(_ => {
      if (_.code == 1) {
        this._appsService.existCurrentCompany = companyId;
        localStorage.setItem('cId', companyId.toString())
      }
      else if (_.code == 2) {
        this.MessageBox(_.message ?? '', 'orange', 'center');
      }
      else {
        this.MessageBox(_.message ?? '', 'warn', 'center');
      }
    }).finally(() => {
      this._appsService.selectedCompany = companyId;
      this._appsService.existCurrentCompany = companyId;
      window.location.reload();
    })

  }

  onSelectedProject(projectId: number) {
    //this._appsService.projects = this.projects;
    //this.onSelectedProject(this.projects[0].id);
    //this.selectedProjectId = projectId;
    this._appsService.selectedProject = projectId;
    this._appsService.projectData.next(projectId);
  }


  onSelectedCompany(companyId: number) {
    this._request.getProjects(companyId).then(_ => {
      this.projects = _;

      this.allProjectData = _;
      this.subProjectControl(_);
    }).finally(() => {
      if (this.projects?.length != 0) {
        this.projects.sort((a, b) => a.projectName.trim().localeCompare(b.projectName.trim()));
        this.projects.forEach(p => { p.projectId = p.id });
        this.selectedProjectId = this.projects[0].id;
        this.changeCompany(this.selectedCompanyId).then(_ => {
          this._appsService.projects = this.projects;
          this.onSelectedProject(this.selectedProjectId);

        });
        this._appsService.isLoaded = true;
      } else {
        this._appsService.isLoaded = false;
        this.projects = [];
        this.changeCompany(this.selectedCompanyId).then(() => {
          this._appsService.projects = this.projects;
        });
        this.MessageBox(this.languageKey("companyOwnedProjectNotFound"), 'orange', 'center');
      }
    });
    this._appsService.logInfo(companyId + "id li şirket görüntülendi");
  }

  forgotPassword(): void {
    if (this.rightSidebar) {
      this.rightSidebar.open();

    }
  }
  openNewPasswordSidebar(): void {
    if (this.rightSidebarNewPassword) {
      this.sidenavOpenPassword = true;
      this._appsService.userPanelOpen.next(this.sidenavOpenPassword);
      this.rightSidebarNewPassword.open();
    } else {
      console.error('Sidenav is undefined');
    }
    this._appsService.logInfo("Yeni şifreye tıklandı");
  }

  closeSidebarPwd() {
    this.sidenavOpenPassword = false;
    this._appsService.userPanelOpen.next(this.sidenavOpenPassword);
  }

  openKvkkModal() {
    this._appsService.logInfo("KVKK modal açıldı (Admin Panel).");
    const dialogRef = this._dialog.open(ModalComponent, {
      width: '60vw',
      height: '100vh',
      data: {
        type: 'kvkk',
        title: 'KVKK ve Gizlilik Sözleşmeleri',
        mode: 'view'
      },
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //console.log('KVKK onayları (Admin Panel):', result);
      }
    });
  }
}
